interface AdminTableBodyProps {
    children: React.ReactNode;
}

export const AdminTableBody = ({ children }: AdminTableBodyProps) => {
    return (
        <tbody className="divide-y divide-gray-200 bg-white">{children}</tbody>
    );
};
